<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit="($event)=> $event.preventDefault()">
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Solicitante"
          label-for="input-1"
      >
        <p>{{ $localStorageService.getNombreCompletoUsuario() }}</p>
      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Clínica"
          label-for="input-1"
      >
        <v-select
            v-model="model.clinica"
            :options="clinicas"
            label="nombreClinica"
            @input="limpiarDatos"
            :reducer="(c)=> c.idClinica "
        ></v-select>
      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Área"
          label-for="input-1"
      >
        <v-select
            placeholder="Selecciona un área"
            v-model="model.area"
            :options="areas"
            label="nombreArea"
            :reduce="(v)=>v.idArea"
        ></v-select>
      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Tipo de reembolso"
          label-for="input-1"
      >
        <v-select
            placeholder="Selecciona un tipo"
            v-model="model.tipoMovimiento"
            :options="tiposReembolso"
            label="text"
            :reduce="(v)=>v.value"
        ></v-select>
      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Paciente"
          label-for="input-1"
      >
        <b-input-group>
          <b-form-checkbox v-model="buscarPorId" >Buscar paciente por ID</b-form-checkbox>
        </b-input-group>
        <b-input-group>
          <b-form-input placeholder="Paciente (minimo 10 caracteres y 2 palabras)" v-model="nombre"/>
          <b-input-group-append>
            <b-button v-on:click="traerPacientesPorNombreLike">
              <b-spinner small variant="info" v-if="pacienteService.loading"/>
              <font-awesome-icon v-else icon="search"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <v-select
            v-model="model.paciente"
            :options="pacienteService.data"
            :reducer="(p)=> p.idPaciente"
            label="nombreCompleto"
            @input="traerDatosPaciente"
        ></v-select>
        <div v-if="saldoBloqueado" style="font-weight: bold; color:red">
          Saldo congelado
        </div>
      </b-form-group>
      <b-form-group v-if="balance != null" class="text-left">
        <label class="text-left">Saldo actual del paciente emisor </label>
        <b-button variant="info" class="float-right" v-if="model.pacienteOrigen !== null"
                  v-on:click="traerSaldo(model.paciente)">
          <font-awesome-icon icon="sync"/>
        </b-button>
        <BalancePorTipoMovimiento v-if="balance!= null" :balance.sync="balance"/>
      </b-form-group>

      <b-form-group
          v-if="balance!= null"
          id="input-group-1"
          label-align="left"
          label="Número de recibo"
          label-for="input-1"
      >
        <span v-if="recibosPaciente.length === 0">El paciente no tiene recibos</span>
        <div v-else>
          <v-select
              placeholder="Selecciona un recibo"
              v-model="model.recibo"
              :options="recibosPaciente"
              label="numeroRecibo"
              :reduce="(v)=>v.idRecibo"
              @input="forSelectRecibo"
          ></v-select>
        </div>

      </b-form-group>

      <b-form-group
          v-if="balance!= null"
          id="input-group-1"
          label-align="left"
          label="Tratamientos a reembolsar"
          label-for="input-1"
      >
        <v-select
            multiple
            persistent-hint
            placeholder="Selecciona los tratamientos"
            v-model="model.tratamientos"
            :options="tratamientos"
            label="textSelect"
            :reduce="(v)=>v.idTratamientoProgramado"
            @input="calcularImporteTratamientos($event)"
        ></v-select>
      </b-form-group>

      <b-form-group
          v-if="balance!= null"
          id="input-group-1"
          label-align="left"
          label="Importe de la solicitud"
          label-for="input-1"
      >
        <b-form-input
            readonly
            v-model="model.monto"
            type="text"
            @keypress="$onlyNumber"
            @keyup="$onlyNumber"
            @paste="$onlyNumber"
        />
      </b-form-group>



      <b-button v-b-modal="'cuestionario-legal'" variant="primary" size="sm">Agregar Cuestionario Legal</b-button>
      <br>
      <span><small>El cuestionario legal es obligatorio*</small></span>



      <!-- The modal -->
      <b-modal
          id="cuestionario-legal"
          ok-title="Aceptar"
          cancel-title="Cerrar"
          size="lg" title="Cuestionario Legal">
        <FormCuestionarioLegal
          :cuestionario.sync="cuestionario"
        />
      </b-modal>

      <BotonYListaSubirArchivos v-if="model.paciente !== null"  padre="Reembolso" :paciente="model.paciente.idPaciente" class="mb-2"
                                v-on:archivos="appendArchivo"></BotonYListaSubirArchivos>

      <br>

      <b-button type="submit" v-if="$localStorageService.can('RE_mv_Reem_crear') && !saldoBloqueado"
                variant="primary" class="mt-3" :disabled="canSend" v-on:click="guardar">Guardar</b-button>

    </b-form>
  </div>
</template>

<script>

import BotonYListaSubirArchivos from "../../../components/archivos/BotonYListaSubirArchivos";
import {AreaService} from "@/apiServices/area/AreaService";
import {PacienteService} from "@/apiServices/paciente/PacienteService";
import {TipoMovimientoService} from "@/apiServices/tipoMovimiento/TipoMovimientoService";
import {MovimientoService} from "@/apiServices/movimiento/MovimientoService";
import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
import _ from "lodash";
import FormCuestionarioLegal from "@/views/movimientos/reembolso/FormCuestionarioLegal";
import BalancePorTipoMovimiento from "../catalogos/TipoMovimiento/BalancePorTipoMovimiento";
import {MovimientoReembolsoCreateDto} from "@/apiServices/dto/movimiento/MovimientoReembolsoCreateDto";
import {CuestionarioLegalCreateDto} from "@/apiServices/dto/movimiento/CuestionarioLegalCreateDto";
import {FiscalesService} from "@/apiServices/fiscales/FiscalesService";
import {TratamientoProgramadoService} from "@/apiServices/tratamiento/TratamientoProgramadoService";


export default {
  name: "FormReembolso",
  components: {FormCuestionarioLegal, BotonYListaSubirArchivos, BalancePorTipoMovimiento},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    clinicas: [],
    buscarPorId: false,
    nombre: '',
    balance: null,
    model: {
      tipoMovimiento: null,
      clinica: null,
      monto: 0,
      paciente: null,
      empleado: null,
      area: null,
      recibo: null,
      tratamientos: []

    },
    cuestionario: {
      motivoSolicitud: null,
      fechaTratamiento: null,
      consistenciaTratamiento: null,
      avanceTratamiento: null,
      seguimientoDentalia: true,
      detalle: null
    },
    areaService: new AreaService(),
    pacienteService: new PacienteService(),
    tipoMovimientoService: new TipoMovimientoService(),
    movimientoService: new MovimientoService(),
    catalogosService: new CatalogosService(),
    fiscalesService: new FiscalesService(),
    tratamientoProgramadoService: new TratamientoProgramadoService(),
    tiposMovimiento: [],
    archivos: [],
    areas: [],
    recibosPaciente: [],
    tratamientos: [],
    tiposReembolso: [],
    importe: 0,
    saldoBloqueado: false
  }),
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.model.empleado = this.$localStorageService.getIdEmpleado();
    this.clinicas = _.orderBy(this.$localStorageService.getClinicas(), ['nombreClinica'], ['asc']);
    this.areas = await this.areaService.listar();
    this.tiposReembolso = await this.tipoMovimientoService.obtenerTiposReembolso();
  },
  methods: {
    guardar() {
      let cuestionario = new CuestionarioLegalCreateDto();
      cuestionario.motivoSolicitud = this.cuestionario.motivoSolicitud;
      cuestionario.fechaTratamiento = this.cuestionario.fechaTratamiento;
      cuestionario.avanceTratamiento = this.cuestionario.avanceTratamiento;
      cuestionario.consistenciaTratamiento = this.cuestionario.consistenciaTratamiento;
      cuestionario.seguimientoDentalia = this.cuestionario.seguimientoDentalia;
      cuestionario.detalle = this.cuestionario.detalle;
      let toSave = new MovimientoReembolsoCreateDto();
      toSave.monto = +this.model.monto;
      toSave.idPaciente = this.model.paciente.idPaciente;
      toSave.idEmpleadoSolicito = this.model.empleado;
      toSave.idClinica = this.model.clinica.idClinica;
      toSave.idTipoMovimiento = this.model.tipoMovimiento;
      toSave.archivos = this.archivos.map(e => e.idArchivo);
      toSave.tratamientos = this.model.tratamientos;
      toSave.idArea = this.model.area;
      toSave.idRecibo = this.model.recibo;
      toSave.cuestionarioLegal = cuestionario;
      this.movimientoService.crearReembolso(toSave).then(() => {
        this.model = {
          tipoMovimiento: null,
          clinica: null,
          monto: null,
          paciente: null,
          empleado: null,
          area: null,
          recibo: null,
          tratamientos: null
        };
        this.cuestionario= {
          motivoSolicitud: null,
          fechaTratamiento: null,
          consistenciaTratamiento: null,
          avanceTratamiento: null,
          seguimientoDentalia: true,
          detalle: null
        };
        this.balance = null;
        this.archivos = [];
        this.model.empleado = this.$localStorageService.getIdEmpleado();
        this.$root.$emit('archivos', []);
      })
    },
    traerPacientesPorNombreLike() {
      this.pacienteService.data = [];
      if (this.buscarPorId === false && this.nombre.length > 9 && this.nombre.split(' ').length >= 2) {
        this.pacienteService.obtenerPacientesPorNombreLike(this.nombre.toUpperCase());
      }else if (this.buscarPorId === true){
        this.pacienteService.obtenerPacientesPorId(this.nombre.toUpperCase());
      }
    },
    appendArchivo(archivos) {
      this.archivos = archivos;
    },
    async forSelectRecibo() {
      this.model.tratamientos = [];
      this.model.monto = 0;
      if (this.model.recibo !== null){
        this.tratamientos = await this.tratamientoProgramadoService.obtenerTratamientosProgramadosPorReciboUnicos(this.model.recibo);
      }
    },
    async calcularImporteTratamientos(seleccionados) {
      this.model.monto = 0;
      seleccionados.forEach((item) => {
        let tratamiento = this.tratamientos.find(trt => trt.idTratamientoProgramado === item);
        this.model.monto += tratamiento.montoPagado
      });

      if(seleccionados.length === 0){
        this.model.monto = 0;
      }

    },
    async traerDatosPaciente(paciente){
      this.$root.$emit('paciente', paciente);
      this.model.tratamientos = null;
      this.model.recibo = null;
      await this.verificarBloqueo(paciente);
      await this.traerSaldo(paciente)
      await this.traerRecibos(paciente);
    },
    async traerSaldo(paciente) {
      this.model.paciente = paciente;
      this.balance = null;
      this.balance = await this.movimientoService.obtenerBalance({idPaciente: paciente.idPaciente});
    },
    async traerRecibos(paciente) {
      this.recibosPaciente = null;
      this.tratamientos = null;
      this.model.paciente = paciente;
      this.recibosPaciente = await this.fiscalesService.obtenerRecibosPagadosPorPaciente(paciente.idPaciente);
    },
    limpiarDatos() {
      this.pacienteService.data = [];
      this.model.paciente = null;
      this.nombre = '';
    },
    verificarBloqueo(paciente){
      this.saldoBloqueado = false;
      this.$http.post(this.$api + "ws/reembolsos/existeReembolsoProceso", {"idPaciente": paciente.idPaciente})
          .then((response) => {
            this.saldoBloqueado = response.data.success;
          });
    },
  },
  computed: {
    isLoading() {
      return this.catalogosService.loading || this.pacienteService.loading || this.tipoMovimientoService.loading || this.movimientoService.loading;
    },
    canSend() {
      return !(
          this.archivos.length > 0 &&
          this.model.monto > 0 &&
          this.model.paciente != null &&
          this.model.clinica != null &&
          this.model.empleado != null &&
          this.model.tipoMovimiento != null &&
          this.model.area != null &&
          this.model.recibo != null &&
          this.cuestionario.motivoSolicitud != null &&
          this.cuestionario.avanceTratamiento != null &&
          this.cuestionario.fechaTratamiento != null &&
          this.cuestionario.consistenciaTratamiento != null &&
          this.cuestionario.detalle != null &&
          this.cuestionario.seguimientoDentalia != null
      );
    }
  }
}
</script>

<style scoped>

</style>
